import { motion } from 'framer-motion';
import Grid from '@mui/material/Grid';

const MotionGrid = motion(Grid);

export default MotionGrid;
